import { smetaModals } from "../../MainPage/Tools/modalManager";
import React from "react";
import HandleTable from "./HandleTable";
import { getModalSectionID, getStyleWindow } from "../../MainPage/Tools/Tools";
import { GetDialogParam, resumeRequest } from "../TokenProcessing";

interface Data {
  json: {
    Params: {
      ObjType?: string;
      Module?: string;
      ObjRef?: string;
      RequestID?: string;
      OnlyView?: string;
      MultiSel?: string;
    };
    CLSID?: string;
    Title?: string;
  };
  subData: {
    props: any;
    func: (data: any) => any;
    from: string;
  };
  requestID: string;
}

export const selectObject = (data: Data) => {
  const { json, subData, requestID } = data;
  if (json.Params) {
    const dialogParam = GetDialogParam(
      json.Params.ObjType,
      json.Params.Module,
      json.Params.ObjRef,
      json.Params.RequestID,
      json.Params.OnlyView,
      json.Params.MultiSel,
    );
    smetaModals.open(
      <HandleTable
        json={dialogParam}
        subData={{
          props: {
            SectionID: getModalSectionID(),
            Buttons: json.Params.OnlyView === "1" ? 2 : undefined,
            ...subData.props,
            ...json.Params,
            ...dialogParam,
            disiableState: true,
            func: subData.func,
            from: subData.from,
            PlaneView: "0",
          },
        }}
      />,
      {
        Title: json.Title || dialogParam.Title,
        style: getStyleWindow(json.CLSID || dialogParam.CLSID || "{7FAC2B20-109D-4406-A757-61674277B71F}"),
        onClose: () => {
          subData.props?.input?.current?.focus();
          resumeRequest(requestID, subData, {});
        },
        callBacks: true,
      },
    );
  }
};
